import { Box, Flex, Text } from "@chakra-ui/react";

import { FragmentType, getFragmentData, graphql } from "@/__generated__";
import WorkspaceIcon from "@/components/shared/WorkspaceIcon";

const SelectWorkspaceItem_Workspace = graphql(`
  fragment SelectWorkspaceItem_Workspace on Workspace {
    name
    ...WorkspaceIcon_Workspace
  }
`);

interface SelectWorkspaceItemProps {
  workspace: FragmentType<typeof SelectWorkspaceItem_Workspace>;
  collapsed?: boolean;
}

function SelectWorkspaceItem({ collapsed, ...props }: SelectWorkspaceItemProps) {
  const workspace = getFragmentData(SelectWorkspaceItem_Workspace, props.workspace);
  return (
    <Flex align="center">
      <WorkspaceIcon workspace={workspace} />
      {!collapsed && (
        <Box ml="3">
          <Text color="text.darker" size="body3" variant="intense">
            {workspace.name}
          </Text>
        </Box>
      )}
    </Flex>
  );
}

export default SelectWorkspaceItem;
